export default from './no-user-posts';



// WEBPACK FOOTER //
// ./app/components/no-user-posts/index.js